import React from 'react'; 

const travellerOuter = (props) => (
    <div className={`mt-4 mb-4`}>{props.children}</div>
);

export default travellerOuter;


// WEBPACK FOOTER //
// ./src/components/Travellers/TravellerOuter/TravellerOuter.js